export default __webpack_public_path__ + "static/BIG_jerry_fencing-8af2bcd7d5ed5bb33b437da20e67e41f.jpg";